import React from 'react';
import {ROLES} from '../../utils/constants';

/**
 * Show/hide components based on role permissions. Default
 * behavior is to show an element if the role matches. There
 * is also an `inverse` option, which does the opposite. Do not
 * show an element if the role matches.
 *
 * @example
 * // Show edit button for owners and collaborators
 * <Permissions role={ROLES.OWNER} owner collaborator/>
 *  <button>{'edit'}</button>
 * </Permissions>
 *
 * // Do NOT show edit button for viewers
 * <Permissions role={ROLES.VIEWER} inverse viewer/>
 *  <button>{'edit'}</button>
 * </Permissions>
 */
function Permissions({
    children,
    collaborator,
    owner,
    role,
    viewer,
    inverse
}) {
    if (
        (collaborator && role === ROLES.COLLABORATOR)
        || (owner && role === ROLES.OWNER)
        || (viewer && role === ROLES.VIEWER)
    ) {
        if (inverse) {
            return null;
        }
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    if (inverse) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return null;
}

Permissions.defaultProps = {
    collaborator: false,
    owner: false,
    viewer: false,
    inverse: false
};

export default Permissions;


// WEBPACK FOOTER //
// ./src/universal/components/permissions/permissions.js